/**
 * @generated SignedSource<<83edf1fa840e1e2cbb5c5a5eac139f64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type KnowledgeDiscoveryKeyPhraseCategory = "ACRONYM" | "AUTO" | "OTHER" | "PROJECT" | "TEAM" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type preloadAutohighlightsQuery_query$data = {
  readonly knowledgeDiscovery: {
    readonly keyPhrases: {
      readonly __typename: "KnowledgeDiscoveryKeyPhraseConnection";
      readonly nodes: ReadonlyArray<{
        readonly category: KnowledgeDiscoveryKeyPhraseCategory;
        readonly keyPhrase: string;
      } | null> | null;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly " $fragmentType": "preloadAutohighlightsQuery_query";
};
export type preloadAutohighlightsQuery_query$key = {
  readonly " $data"?: preloadAutohighlightsQuery_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "inputText"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jiraAssigneeAccountId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "jiraReporterAccountId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "name": "preloadAutohighlightsQuery_query",
  "selections": [
    {
      "concreteType": "KnowledgeDiscoveryQueryApi",
      "kind": "LinkedField",
      "name": "knowledgeDiscovery",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "entityAri",
              "variableName": "entityAri"
            },
            {
              "kind": "Variable",
              "name": "inputText",
              "variableName": "inputText"
            },
            {
              "kind": "Variable",
              "name": "jiraAssigneeAccountId",
              "variableName": "jiraAssigneeAccountId"
            },
            {
              "kind": "Variable",
              "name": "jiraReporterAccountId",
              "variableName": "jiraReporterAccountId"
            },
            {
              "kind": "Variable",
              "name": "workspaceId",
              "variableName": "workspaceId"
            }
          ],
          "kind": "LinkedField",
          "name": "keyPhrases",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "KnowledgeDiscoveryKeyPhrase",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "keyPhrase"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "category"
                    }
                  ]
                }
              ],
              "type": "KnowledgeDiscoveryKeyPhraseConnection"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "message"
                }
              ],
              "type": "QueryError"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "e217dd52ca3b019fe148e9b8034b7cd9";

export default node;
